<app-modal
  [title]="getTitle()"
  [saveButtonName]="getSaveButtonName()"
  [cancelButtonName]="getCancelButtonName()"
  (save)="onSave()"
  [isDataLoaded]="!!data"
  [shouldSaveBeDisabled]="!isValid || blockInput"
>
  <ng-container body>
    <!-- <mat-dialog-content> -->

    <div class="body-container">
      <form [formGroup]="form">
        <div class="organization-logo">
          @if (form.get('logo')?.value) {
            <div class="logo-container">
              <div
                class="unset-logo-button"
                (click)="form.get('logo').setValue(null)"
                (keydown.enter)="form.get('logo').setValue(null)"
                (keydown.space)="form.get('logo').setValue(null)"
                tabindex="0"
              >
                <mat-icon>close</mat-icon>
              </div>
              <img
                [src]="form.get('logo').value"
                (click)="fileInput.click()"
                (keydown.enter)="fileInput.click()"
                (keydown.space)="fileInput.click()"
                alt="logo"
                tabindex="0"
              />
            </div>
            <div class="upload-logo-container">
              <span>{{ 'CLICK_LOGO' | translate }}</span>
              <span style="margin-top: 1em">{{ 'PREF_IMAGE_SIZE' | translate }}</span>
            </div>
          } @else {
            <div
              class="logo-container"
              (click)="fileInput.click()"
              (keydown.enter)="fileInput.click()"
              (keydown.space)="fileInput.click()"
              tabindex="0"
            >
              <div class="icon-container">
                <mat-icon>corporate_fare</mat-icon>
              </div>
            </div>
            <div class="upload-logo-container">
              <button
                class="upload-logo-button"
                type="button"
                mat-raised-button
                (click)="fileInput.click()"
              >
                {{ 'ORGANIZATION.UPLOAD_LOGO' | translate }}
              </button>
              <span>{{ 'PREF_IMAGE_SIZE' | translate }}</span>
            </div>
          }
        </div>

        @for (input of inputs; track input) {
          <section>
            <app-emu-input
              [attr.data-cy]="input.dataCy"
              [name]="input.displayName"
              [integer]="input?.type === 'number'"
              [formControlName]="input.name"
              autocompleteTag="{{ input.autocompleteTag }}"
            ></app-emu-input>
          </section>
        }

        <section>
          <app-emu-list-input-autocomplete
            formControlName="timezone"
            [name]="'PROFILE.TIMEZONE'"
            (valueChange)="timezoneInput$.next($event)"
            [clearButtonHidden]="true"
            [filteredOptions$]="filteredTimezones$"
            data-cy="timezone"
          >
            <ng-template let-item>
              <p class="device-name" [attr.data-cy]="item">
                {{ item }}
              </p>
            </ng-template>
          </app-emu-list-input-autocomplete>
        </section>
      </form>
    </div>
    <input
      data-cy="input-logo"
      hidden
      (change)="onFileSelected()"
      #fileInput
      type="file"
      id="file"
      accept="image/*"
    />
    <!-- </mat-dialog-content> -->
  </ng-container>
</app-modal>
